import { useGlobal } from "../contexts/globalContext";
import { useParams, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

function SearchBoxCreator({ isCreator = false }) {
  const navigate = useNavigate();
  const { tag, min, max } = useParams();
  const { keywordCreator, setKeywordCreator, sort, pageNumber } = useGlobal();

  function submitHandler(e, overrideMax, overrideMin) {
    e.preventDefault();

    let route = "";
    if (tag) route = `/user/creator/${tag}/search`;
    else if (isCreator) route = `/profile/creator/search`;
    else route = "/search";

    if (keywordCreator.trim()) route += `/${keywordCreator}`;
    if (sort) route += `/sort/${sort}`;
    if (overrideMin) route += `/min/${overrideMin}`;
    if (overrideMax) route += `/max/${overrideMax}`;
    if (pageNumber) route += `/page/${pageNumber}`;

    navigate(route);
  }

  return (
    <form onSubmit={(e) => submitHandler(e, min, max)} className="flex w-full items-center">
      <input
        type="text"
        name="q"
        onChange={(e) => setKeywordCreator(e.target.value)}
        value={keywordCreator}
        placeholder="Search Products"
        className="h-12 w-full min-w-[200px] rounded-l-2xl rounded-r-none border border-r-0 border-slate-200 bg-white px-4 text-sm text-slate-800 outline-none focus:border-sky-300 focus:ring-2 focus:ring-sky-100"
      />
      <button
        type="submit"
        className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-r-2xl border border-sky-600 bg-sky-600 text-white transition hover:bg-sky-700"
        aria-label="Search products"
      >
        <FiSearch className="text-lg" />
      </button>
    </form>
  );
}

export default SearchBoxCreator;
